/* eslint-disable @typescript-eslint/ban-ts-comment */
import { EventHandlersPool } from '@/infranstructure/utils/EventHandlerPool'
import VueRouter from 'vue-router'
import { Dictionary } from 'vue-router/types/router'
import { PaymentRedirectMessage } from './pagesCommands.types'
import api from '@/utils/axios'

const eventHandlersPool = new EventHandlersPool(window, 'message')
let onRedirectPostMessageKey: string | null = null

export const paymentSuccessMessage = 'avissign.payment.success'
export const paymentFailMessage = 'avissign.payment.fail'

export function redirect(router: VueRouter) {
  return function ({ id, uid, routeName, query }: { id: string, uid: string, routeName: string, query?: Dictionary<string> }) {
    router.push({ name: routeName, params: { id, uid }, query }).then(() => {
      document.location.reload()
    })
  }
}

export function paymentSuccessRedirect(router: VueRouter) {
  // const functor = redirect(router)
  return function ({ id, uid }: { id: string, uid: string }) {
    // functor({ id, uid, routeName: 'payment-success' })
    // functor({ id, uid, routeName: 'signing-page' })
    document.location.reload()
  }
}

export function paymentFailRedirect(router: VueRouter) {
  const functor = redirect(router)
  return async function ({ id, uid, query }: { id: string, uid: string, query?: Dictionary<string> }) {
    try {
      await api.post(`/cancelPayment/${id}`)
    } finally {
      functor({ id, uid, routeName: 'payment-fail', query })
    }
  }
}

export function redirectPostMessage(message: PaymentRedirectMessage) {
  parent.postMessage(message, '*')
}

export function onRedirectPostMessage(router: VueRouter) {
  return function ({ id, uid }: { id: string, uid: string }) {
    if (onRedirectPostMessageKey && eventHandlersPool.has(onRedirectPostMessageKey)) {
      return
    }
    const eventHandler = async (event: Event) => {
      // console.log('onRedirectPostMessage', event, id, uid, (event as any).data)
      // @ts-ignore
      if ('data' in event && (event.data as PaymentRedirectMessage)?.title === paymentSuccessMessage) {
        paymentSuccessRedirect(router)({ id, uid })
      }
      // @ts-ignore
      if ('data' in event && (event.data as PaymentRedirectMessage)?.title === paymentFailMessage) {
        // @ts-ignore
        const failMessage = (event.data as PaymentRedirectMessage)?.description
        const query = failMessage ? { failMessage } : undefined
        // console.log('onRedirectPostMessage query', query)
        await paymentFailRedirect(router)({ id, uid, query })
      }
    }
    onRedirectPostMessageKey = eventHandlersPool.add(eventHandler) // This is the "add" method simple, because when the event is raised the page will be reloaded
  }
}
